import * as React from 'react';
import classNames from 'classnames';
import { NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './TextWrapper.module.esm.js';
import themes from '../../themes.module.esm.js';

var TEXT_POSITION = {
    left: 'left',
    right: 'right',
};
var TextWrapper = function (_a) {
    var _b;
    var body = _a.body, customerName = _a.customerName, textPosition = _a.textPosition, theme = _a.theme, videoPadding = _a.videoPadding, primaryLink = _a.primaryLink;
    return (React.createElement("div", { className: classNames(styles.reviewContainer, (_b = {},
            _b[styles.reviewContainerLeft] = textPosition === 'left',
            _b[styles.reviewContainerVideo] = videoPadding,
            _b)) },
        React.createElement("div", { className: styles.leftQuoteWrapper },
            React.createElement("span", { className: classNames(themes[theme], styles.leftQuote) }, "\u201C")),
        React.createElement(NvMarkdown, { className: styles.reviewBody }, "".concat(body, "\u201D")),
        React.createElement("p", { className: classNames(themes[theme], styles.customerName) }, "- ".concat(customerName)),
        primaryLink && (React.createElement(BaseNucleobaseComponent, { classes: { link: classNames(styles.button, 'nv-button nv-button-secondary') }, source: primaryLink }))));
};

export { TEXT_POSITION, TextWrapper };
//# sourceMappingURL=TextWrapper.esm.js.map
